import moment from 'moment';
import angular from 'angular';

import multiPickerTemplate from '../../../../components/assetpicker/asset.multi.picker.html';
import template from './tag.bulk.html';

const DATETIME = 'Datetime';
const DATE = 'Date';
const HYPERLINK = 'Hyperlink';
const TEXT = 'Text';
const INTEGER = 'Integer';
const DECIMAL = 'Decimal';

class TagBulkApplyController {
  constructor(
    $scope,
    $rootScope,
    $q,
    $element,
    $timeout,
    $uibModal,
    $filter,
    EquipmentService,
    TimezoneService,
    gettextCatalog,
    appSettings,
    tagsService,
    $ngRedux,
  ) {
    'ngInject';

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;
    this.$filter = $filter;
    this.EquipmentService = EquipmentService;
    this.TimezoneService = TimezoneService;
    this.gettextCatalog = gettextCatalog;
    this.appSettings = appSettings;
    this.tagsService = tagsService;
    this.store = $ngRedux;

    this.loading = true;
    this.animationsEnabled = true;
    this.selectedTags = [];
    this.values = {};
    this.opened = {};
    this.focus = {};
    this.datetimedate = {};
    this.cachedAttrs = {};

    this.assets = []; //list of equipments to send to the database
    this.postRemoval = [];
    this.removeFlags = {};
    this.filteredAssetList = [];
    this.assetByPage = [];
    this.searchText = '';
    this.previousSearchText = '';

    this.assetPredicate = 'name';
    this.assetReverse = false;

    this.assetPage = 1;
    this.itemsPerPage = 5;
    this.maxSize = 3;

    this.onlyNumbersReg = /[0-9]+/;

    this.isAllSelected = false;
    this.csvUnresolvedEsns = [];
    this.csvAttributeKeys = [];
    this.csvAssetAttributes = {};
    this.csvMode = false;
    this.csvProcessing = false;
    this.csvFileName = '';
    this.csvResolvedCount = 0;
    this.csvUpdateResults = [];
    this.csvSuccessCount = 0;
    this.csvFailedResults = [];
    this.csvInvalidHeaders = [];
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis)(this);
    this.csvMode = false;

    this.EquipmentService.getAllTags().then(
      (response) => this.tagsFromResponse(response),
      (error) => {
        let errorMsg = this.errorFromResponse(error);

        this.onLoadErrorFlag = true;
        this.onLoadErrorText = errorMsg;
        this.loading = false;
      },
    );

    this.dateFormat = this.appSettings.GetDateFormat();
  }

  mapStateToThis(state) {
    const { attributes } = state;

    let readonly = [];
    if (attributes != null && attributes.secured != null && attributes.secured.readonly) {
      readonly = readonly.concat(attributes.secured.readonly);
    }

    return {
      readonlyAttributes: readonly,
    };
  }

  $postLink() {
    const fileInput = this.$element[0].querySelector('.csv-file-input');
    if (fileInput) {
      fileInput.addEventListener('change', (e) => {
        this.$scope.$apply(() => this.onCsvFileSelected(e.target));
      });
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }

  // Populate tags from API
  tagsFromResponse(response) {
    const allTags = response.data.data;
    this.tags = allTags
      .filter((t) => t.key != null && this.readonlyAttributes.indexOf(t.key.toLowerCase()) === -1)
      .map((tag) => {
        if (tag.dataType === DATETIME) {
          const { min, max } = tag.range || {};

          if (min) tag.range.min = moment(min).toDate();
          if (max) tag.range.max = moment(max).toDate();
        }
        return tag;
      });

    this.loading = false;
  }

  // Error from API
  errorFromResponse(error) {
    let errorMsg = this.gettextCatalog.getString(
      'An error occurred while retrieving attribute information',
    );

    const {
      data: { message },
      status,
      statusText,
    } = error || {};

    if (status)
      errorMsg = `${message ? message : errorMsg
        } : ${status.toString()} - ${statusText.toString()}`;
    else errorMsg += this.gettextCatalog.getString('. Please try again later');
    return errorMsg;
  }

  //Sort filteredEquipmentList
  orderAssetList(predicate) {
    if (predicate === this.assetPredicate) {
      this.assetReverse = !this.assetReverse;
    } else {
      this.assetReverse = false;
    }
    this.assetPredicate = predicate;
    this.GTM_AssetsListChanged('attributesBulkApplyAssetsOrderChanged');
  }

  //applyFilter searchs the equipments[] for anything matching the search input.
  applyAssetFilter(event) {
    if (!event && this.previousSearchText === this.searchText) return;
    this.filteredAssetList = this.$filter('filter')(this.assets, this.searchText);
    this.previousSearchText = this.searchText;
    this.GTM_AssetsListChanged(event || 'attributesBulkApplyAssetsFiltered');
  }

  openAssets() {
    const assets = this.assets;
    const modalInstance = this.$uibModal.open({
      animation: this.animationsEnabled,
      template: multiPickerTemplate,
      controller: 'AssetMultiPickerController',
      size: 'lg',
      resolve: {
        singleSelect: false,
        requiresSelection: true,
        selectedAssets: function () {
          const selected = {};

          if (assets) {
            for (let i = 0; i < assets.length; i++) {
              let e = assets[i];
              selected[e.id] = e;
            }
          }
          return selected;
        },
        maxSelection: function () {
          return 0;
        },
      },
    });

    modalInstance.result.then((selectedAssets) => {
      this.assets = [];
      for (let key in selectedAssets.result) {
        this.assets.push(selectedAssets.result[key]);
      }
      this.cachedAttrs = {};
      this.cacheAttrs(selectedAssets.result);
      this.isAllSelected = false;
      this.applyAssetFilter('attributesBulkApplyAssetsChanged');
    });
  }

  onCsvFileSelected(input) {
    if (!input.files || !input.files[0]) return;
    const file = input.files[0];
    input.value = '';

    this.csvFileName = file.name;
    this.csvProcessing = true;
    this.csvResolvedCount = 0;
    this.csvUnresolvedEsns = [];
    this.csvUpdateResults = [];
    this.csvSuccessCount = 0;
    this.csvFailedResults = [];
    this.csvInvalidHeaders = [];
    this.successFlag = false;

    const reader = new FileReader();
    reader.onload = (e) => {
      const parsed = this._parseCsvRows(e.target.result);
      this.$scope.$apply(() => this._processCsvRows(parsed));
    };
    reader.readAsText(file);
  }

  _parseCsvRows(text) {
    const lines = text.split(/\r?\n/).filter((l) => l.trim().length > 0);
    if (lines.length < 2) return { attrHeaders: [], rows: [] };

    const headers = lines[0].split(',').map((h) => h.trim());
    const esnIndex = headers.findIndex((h) => h.toLowerCase() === 'esn');
    if (esnIndex === -1) return { attrHeaders: [], rows: [] };

    const attrHeaders = headers.filter((_, i) => i !== esnIndex);

    const rows = lines.slice(1).map((line) => {
      const cols = line.split(',').map((c) => c.trim());
      const esn = cols[esnIndex];
      const attrs = {};
      headers.forEach((h, i) => {
        if (i !== esnIndex && cols[i] && cols[i].length > 0) {
          attrs[h] = cols[i];
        }
      });
      return { esn, attrs };
    });

    return { attrHeaders, rows };
  }

  _processCsvRows({ attrHeaders, rows }) {
    const validKeys = new Set((this.tags || []).map((t) => t.key));
    const filteredHeaders = attrHeaders.filter((h) => validKeys.has(h));
    const invalidHeaders = attrHeaders.filter((h) => !validKeys.has(h));

    if (invalidHeaders.length > 0) {
      this.csvInvalidHeaders = invalidHeaders.map((h) => {
        const suggestion = (this.tags || []).find((t) => t.key.toLowerCase() === h.toLowerCase());
        return { header: h, suggestion: suggestion ? suggestion.key : null };
      });
      this.csvProcessing = false;
      return;
    }

    this.csvAttributeKeys = filteredHeaders;
    this.csvMode = filteredHeaders.length > 0;
    this.csvAssetAttributes = {};

    const brand = this.$rootScope.currentUser.claims['tenant:brand'];
    const serialField = brand === 'glc' ? 'machine Serial Number' : 'onei3:serial';

    const lookups = rows.map(({ esn, attrs }) =>
      this.EquipmentService
        .getEquipmentSearch(null, { limit: 10 }, null, null, null, null, { [serialField]: esn })
        .then(({ data }) => {
          if (data.hits && data.hits.length > 0) {
            const asset = data.hits[0];
            const filteredAttrs = {};
            filteredHeaders.forEach((k) => { if (attrs[k] !== undefined) filteredAttrs[k] = attrs[k]; });
            this.csvAssetAttributes[asset.id] = filteredAttrs;
            return asset;
          }
          this.csvUnresolvedEsns.push(esn);
          return null;
        })
        .catch(() => {
          this.csvUnresolvedEsns.push(esn);
          return null;
        })
    );

    const safetyTimeout = this.$timeout(() => {
      if (this.csvProcessing) {
        this.csvProcessing = false;
      }
    }, 30000);

    return this.$q.all(lookups)
      .then((results) => {
        this.$timeout.cancel(safetyTimeout);
        const resolved = results.filter(Boolean);
        const existingIds = new Set(this.assets.map((a) => a.id));
        resolved.forEach((asset) => {
          if (!existingIds.has(asset.id)) {
            this.assets.push(asset);
            existingIds.add(asset.id);
          }
        });
        const assetMap = {};
        this.assets.forEach((a) => (assetMap[a.id] = a));
        this.cachedAttrs = {};
        this.cacheAttrs(assetMap);
        this.isAllSelected = false;
        this.csvResolvedCount = resolved.length;
        this.csvProcessing = false;
        this.applyAssetFilter('attributesBulkApplyAssetsChanged');
      })
      .catch(() => {
        this.$timeout.cancel(safetyTimeout);
        this.csvProcessing = false;
      });
  }

  selectAllAssets() {
    if (this.assets.length > 0) {
      this.assets.forEach((asset) => {
        this.removeFlags[asset.id] = this.isAllSelected;
      });
    }
    this.GTM_AssetsListChanged(
      this.isAllSelected
        ? 'attributesBulkApplyAssetsAllSelected'
        : 'attributesBulkApplyAssetsAllDeselected',
    );
  }

  removeAssets() {
    if (this.sending) {
      return;
    }
    const newList = [];
    this.assets.forEach((asset) => {
      if (!this.removeFlags[asset.id]) {
        newList.push(asset);
      }
    });
    this.assets = angular.copy(newList);
    this.removeFlags = {};
    if (this.csvMode && this.assets.length === 0) {
      this.csvMode = false;
      this.csvAssetAttributes = {};
      this.csvAttributeKeys = [];
      this.csvFileName = '';
    }
    this.applyAssetFilter('attributesBulkApplyAssetsSelectedRemoved');
  }

  parseTags(asset) {
    const toDisplay = [];
    const seen = new Set();
    for (let key in asset.attrs) {
      for (let j = 0; j < this.tags.length; j++) {
        const tag = this.tags[j];
        if (key.toLowerCase() === tag.key.toLowerCase() && !seen.has(tag.key)) {
          seen.add(tag.key);
          toDisplay.push({
            key: tag.key,
            value: asset.attrs[key],
            index: j,
            dataType: tag.dataType,
            id: tag.id,
          });
          break;
        }
      }
    }
    return toDisplay;
  }

  cacheAttrs(assets) {
    for (const key in assets) {
      this.cachedAttrs[key] = {};
      for (let attr in assets[key].attrs) {
        let found = false;
        for (let j = 0; j < this.tags.length; j++) {
          if (attr.toLowerCase() === this.tags[j].key.toLowerCase()) {
            found = true;
            break;
          }
        }
        if (!found) {
          this.cachedAttrs[key][attr] = assets[key].attrs[attr];
        }
      }
    }
  }

  appendTag(tag) {
    const { id, dataType, freeform, range } = tag;

    this.selectedTags.push(tag);
    this.values[id] = {
      tag: id,
    };

    if (dataType === DATE || dataType === DATETIME) {
      this.opened[id] = false;

      const result = this.getDateValue(range, freeform, dataType);

      this.values[id] = { ...result };

      if (result.maxValue || result.minValue) {
        this.values[id].value = result.maxValue ? result.maxValue : result.minValue;
        this.datetimedate[id] = this.values[id].value;
      }
    }

    tag.selected = true;
    this.newTag = undefined;
    this.focus[id] = true;
    this.GTM_TagsChanged('attributesBulkApplyAttributeAdded');
  }

  getDateValue(range = {}, freeform, dataType) {
    let dateValue = {
      value: moment().toDate(),
    };

    if (freeform) {
      return dateValue;
    } else {
      if (range.min) {
        const minRange = moment(range.min).toDate();
        dateValue.value = minRange;

        if (dataType === DATETIME) {
          dateValue.minValue = minRange;
        }
      }

      if (range.max) {
        const maxRange = moment(range.max).toDate();
        dateValue.value = maxRange;

        if (dataType === DATETIME) {
          dateValue.maxValue = maxRange;
        }
      }
    }
    return dateValue;
  }

  removeTag(index) {
    const selectedTag = this.selectedTags[index];
    selectedTag.selected = false;
    delete this.values[selectedTag.id];
    delete this.focus[selectedTag.id];
    this.selectedTags.splice(index, 1);
    this.GTM_TagsChanged('attributesBulkApplyAttributeRemoved');
  }

  filterSelected(tag) {
    if (tag.selected) {
      return false;
    } else {
      return true;
    }
  }

  roundInt(val) {
    if (val) {
      return Math.floor(val);
    }
  }

  open(index) {
    this.opened[index] = true;
  }

  datetimeValidCheck(id) {
    if (!this.datetimedate[id]) return false;
    const temp = moment(this.datetimedate[id]).toDate();
    const value = this.values[id].value;
    if (value) {
      temp.setHours(value.getHours());
      temp.setMinutes(value.getMinutes());
      temp.setSeconds(value.getSeconds());
    }

    const valueForId = this.values[id];
    return (
      (valueForId.minValue == null || temp >= valueForId.minValue) &&
      (valueForId.maxValue == null || temp <= valueForId.maxValue)
    );
  }

  checkAllDatetimes() {
    for (let selectedTag in this.selectedTags) {
      if (selectedTag.dataType === DATETIME && !selectedTag.freeform) {
        if (!this.datetimeValidCheck(selectedTag.id));
        return false;
      }
    }
    return true;
  }

  generateTooltip(tag) {
    return this.tagsService.generateTooltip(tag, this.dateFormat);
  }

  applyTags() {
    this.successFlag = false;

    if (
      this.sending ||
      this.$scope.bulkForm.$invalid ||
      !this.checkAllDatetimes() ||
      this.assets.length <= 0 ||
      (!this.selectedTags.length && !this.csvMode)
    ) {
      return;
    }

    this.sending = true;
    this.errorFlag = false;

    const newTags = {};
    for (let j = 0; j < this.selectedTags.length; j++) {
      const selectedTag = this.selectedTags[j];
      const selectedTagId = selectedTag.id;
      const selectedTagValue = this.values[selectedTagId].value;
      let toAdd = {
        key: selectedTag.key.substring(0, 1).toLowerCase() + selectedTag.key.substring(1),
      };
      switch (selectedTag.dataType) {
        case HYPERLINK:
        case TEXT:
        case INTEGER:
        case DECIMAL:
          toAdd.v = selectedTagValue;
          break;
        case DATE:
          toAdd.v = this.$filter('date')(selectedTagValue, 'yyyy-MM-dd');
          break;
        case DATETIME:
          if (typeof selectedTagValue === 'string') {
            toAdd.v = selectedTagValue;
          } else {
            toAdd.v = moment(this.datetimedate[selectedTagId]).set({
              hour: selectedTagValue.getHours(),
              minutes: selectedTagValue.getMinutes(),
              seconds: selectedTagValue.getSeconds(),
              milliseconds: 0,
            });
          }
          break;
      }
      newTags[toAdd.key] = toAdd.v;
    }

    const changeset = [];
    const submitAssets = angular.copy(this.assets);
    const submittedCsvIds = this.csvMode
      ? submitAssets.map((a) => a.id).filter((id) => id in this.csvAssetAttributes)
      : [];
    for (let i = 0; i < submitAssets.length; i++) {
      const asset = submitAssets[i] || {};

      let values;

      if (this.csvMode) {
        const csvAttrs = this.csvAssetAttributes[asset.id] || {};
        const canonicalKeyMap = {};
        (this.tags || []).forEach((t) => { canonicalKeyMap[t.key.toLowerCase()] = t.key; });
        const merged = {};
        for (let k in asset.attrs || {}) {
          const canonical = canonicalKeyMap[k.toLowerCase()] || k;
          merged[canonical] = asset.attrs[k];
        }
        for (let key in csvAttrs) {
          if (csvAttrs[key] !== null && csvAttrs[key] !== undefined) {
            merged[key] = String(csvAttrs[key]);
          }
        }
        changeset.push({ id: asset.id, op: 'overwrite', values: merged });
        continue;
      } else {
        for (let tag in newTags) {
          asset.attrs[tag] = newTags[tag];
        }
        for (let cached in this.cachedAttrs[asset.id]) {
          asset.attrs[cached] = this.cachedAttrs[asset.id][cached];
        }
        values = asset.attrs;
      }

      changeset.push({
        id: asset.id,
        op: 'overwrite',
        values: values,
      });
    }

    this.EquipmentService.batchPatchAttrs(changeset).then(
      (response) => {
        this.isEditing = false;
        this.sending = false;
        this.successFlag = true;
        this.assets = response.data;
        this.applyAssetFilter('attributesBulkApplyAssetsApplied');
        this.removeFlags = {};

        if (this.csvMode) {
          const returnedIds = new Set((response.data || []).map((a) => a.id));
          this.csvSuccessCount = submittedCsvIds.filter((id) => returnedIds.has(id)).length;
          this.csvFailedResults = submittedCsvIds
            .filter((id) => !returnedIds.has(id))
            .map((id) => {
              const asset = submitAssets.find((a) => a.id === id);
              return { name: asset ? asset.name : id, failed: ['update could not be saved'] };
            });
        }
      },
      (error) => {
        let errorMsg = this.errorFromResponse(error);

        this.errorFlag = true;
        this.errorText = errorMsg;
        this.sending = false;
      },
    );
  }

  toggleRemoval(asset) {
    this.applyAssetFilter(
      this.removeFlags[asset.id]
        ? 'attributesBulkApplyAssetSelected'
        : 'attributesBulkApplyAssetDeselected',
    );
  }

  GTM_TagsChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: this.selectedTags.length,
      },
    });
  }

  GTM_AssetsListChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: this.assets.length,
        totalFiltered: this.filteredAssetList.length,
        totalSelected: this.assets.filter((asset) => this.removeFlags[asset.id]).length,
        pageNumber: this.assetPage,
        sortDirection: this.assetReverse ? 'descending' : 'ascending',
      },
    });
  }
}

export const TagBulkApplyComponent = {
  template: template,
  controller: TagBulkApplyController,
  controllerAs: 'vm',
  bindings: {},
};
